<template>
    <div class="practiveitem2-container">
        <div class="practive-toptitle">
            <p>学前卫生保育与膳食</p>
            <span>综合实训数字资源系统（PC版）</span>
        </div>
        <p class="practive-subtitle">服务于学前儿童生理结构认知、膳食营养与健康等专业内容，提供卫生与保健所涉及到的教学内容和实训内容的虚拟仿真再现。系统实训任务通过三维场景、实训任务发布、考题、互动学习游戏、交互操作等方式，对教学相关知识、实训等内容进行交互式练习。实训过程中具备计时、计分、倒计时、结果记录、成绩统计、成绩排行等功能。</p>
        <div class="practive-pics">
            <img :src="require('@/assets/images/index/item5.png')" alt="">
            <img :src="require('@/assets/images/index/item6.png')" alt="">
        </div>
        <p class="pics-tips">用户界面</p>
        <div class="banquan">© 2021 文泉幼教. 版权所有. 学前教育理虚实一体化实训基地.</div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            
        }
    },
    created() {},
    mounted() {},
    methods: {
        
    }
}
</script>
<style lang='scss' scoped>
.practiveitem2-container {
    .practive-toptitle {
        height: 72px;
        background: linear-gradient(90deg, #0A56B1 0%, #607FFF 100%);
        border-radius: 8px;
        width: 100%;
        color: #fff;
        padding: 9px 30px;
        box-sizing: border-box;
        &>p {
            font-size: 24px;
            font-weight: 500;
            line-height: 33px;
        }
        &>span {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }
    }
    .practive-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        padding: 30px 26px;
        box-sizing: border-box;
    }
    .practive-pics {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        &>img {
            width: 420px;
        }
    }
    .pics-tips {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin: 15px 0 0;
        text-align: center;
    }
    .pics3 {
        width: 500px;
        text-align: center;
        display: block;
        margin: auto;
    }
    .banquan {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        height: 60px;
        background: #F7F7F7;
        border-radius: 8px;
        padding: 20px 30px;
        box-sizing: border-box;
        margin-top: 40px;
        margin-bottom: 80px;
    }
}
</style>